import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Camera, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { BienDetailPage } from "@/pages/biens/BienDetailPage";
import { closeGate } from "./TempPublishLoginPage";

/**
 * Fiche bien du module /publi-temp.
 *
 * Wrappe BienDetailPage en :
 *  - injectant bienIdOverride depuis l URL (sans dépendre du contexte Route
 *    pour rester explicite),
 *  - forçant roleOverride = admin (l externe a une dev session admin),
 *  - masquant les 3 sections opérationnelles (Locataires / ELS / SRS),
 *  - désactivant les bannières de validation des champs requis.
 *
 * Top bar minimaliste : retour à la liste + déconnexion. Pas de sidebar.
 */
export function TempPublishDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    closeGate();
    await signOut();
    navigate("/publi-temp/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="bg-surface border-b border-border px-6 py-3 flex items-center justify-between sticky top-0 z-10">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/publi-temp")}
            className="inline-flex items-center gap-1.5 text-xs text-text-muted hover:text-text-primary cursor-pointer transition-colors"
          >
            <ArrowLeft size={13} />
            Mes biens
          </button>
          <span className="text-text-muted">/</span>
          <Camera size={16} className="text-accent" />
          <h1 className="text-sm font-semibold text-text-primary">
            Fiche bien
          </h1>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-xs text-text-muted hover:text-text-primary cursor-pointer transition-colors"
        >
          <LogOut size={13} />
          Déconnexion
        </button>
      </header>

      <main className="flex-1 px-4 md:px-6 py-6 max-w-7xl w-full mx-auto">
        <BienDetailPage
          bienIdOverride={id}
          roleOverride="admin"
          hideSections={["locataires", "etatDesLieux", "finalisationSrs"]}
          skipRequiredValidation
          hidePermissionsTab
        />
      </main>
    </div>
  );
}
